import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Unlock, RefreshCw, Magnet, Eye, Heart } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursBenefits() {
  const benefits = [{
    icon: ShieldCheck,
    title: 'Mentalitatea ta se schimbă',
    desc: 'Nu mai trăiești cu frica zilei de mâine. Înveți să privești banii cu calm și încredere.'
  }, {
    icon: Unlock,
    title: 'Te eliberezi de blocaje',
    desc: 'Vinovăția și frica se dizolvă pe măsură ce lucrezi cu subconștientul tău.'
  }, {
    icon: RefreshCw,
    title: 'Înțelegi fluxul banilor',
    desc: 'Când înțelegi cum să primești și cum să dai, totul se echilibrează natural.'
  }, {
    icon: Magnet,
    title: 'Atragi oportunități',
    desc: 'Oportunitățile apar când tu ești pregătită să le primești, schimbând energia.'
  }, {
    icon: Eye,
    title: 'Claritate și control',
    desc: 'Nu mai eviți situația reală. O privești cu curaj, cu calm și cu un plan clar.'
  }, {
    icon: Heart,
    title: 'Bucurie fără vinovăție',
    desc: 'Înveți că a te bucura de bani e sănătos și că abundența e dreptul tău divin.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-678">
      <div className="max-w-7xl mx-auto px-6" data-id="element-679">
        <SectionHeading title="Ce se schimbă concret după acest curs" data-id="element-680" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-681">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-682">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-683">
                  <Icon className="w-8 h-8" data-id="element-684" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-685">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-686">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-687">
          <CTAButton data-id="element-688" />
        </motion.div>
      </div>
    </section>;
}